import React from 'react';
import { MenuItem, Select } from '@mui/material';

const DropdownCustom = props => {
  const { member, isVE, onChange } = props;
  return (
    <Select
      disabled={isVE}
      value={member?.domain?.elements.filter(f => f.selected == true)[0].name}
      onChange={e => {
        onChange(e);
      }}
      className="custom-dropdown"
      inputProps={{ 'aria-label': 'Without label' }}
    >
      {member?.domain?.elements.map((val, i) => {
        return (
          <MenuItem
            key={i + val.name}
            value={val.name}
            className={val?.state == 'green' ? '' : 'gray-shade-option'}
          >
            {val.description}
          </MenuItem>
        );
      })}
    </Select>
  );
};
export default DropdownCustom;
